import React from 'react';
import { Tooltip, Zoom } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#333333',
        color: '#ffffff',
        boxShadow: theme.shadows[4],
        fontSize: 12,
        borderRadius: '4px',
        padding: '8px 12px',
    },
    [`& .MuiTooltip-arrow`]: {
        color: '#333333',
    },
}));


/**
 * Standardized Tooltip component for the application.
 * 
 * Props:
 * - title: The content of the tooltip (string or Element)
 * - children: The element that triggers the tooltip
 * - placement: prompt 'top', 'bottom', 'left', 'right' (default: 'top')
 * - noBackground: boolean. If true, the tooltip background is transparent (useful for custom rich content)
 * - ...other Tooltip props
 */
const AppTooltip = ({ children, title, placement = "top", noBackground = false, ...props }) => {

    if (noBackground) {
        return (
            <Tooltip
                title={title}
                placement={placement}
                TransitionComponent={Zoom}
                arrow
                componentsProps={{
                    tooltip: {
                        sx: {
                            bgcolor: 'transparent',
                            boxShadow: 'none',
                            p: 0,
                        }
                    }
                }}
                {...props}
            >
                {children}
            </Tooltip>
        );
    }

    return (
        <StyledTooltip
            title={title}
            placement={placement}
            TransitionComponent={Zoom}
            arrow
            {...props}
        >
            {children}
        </StyledTooltip>
    );
};

export default AppTooltip;
